import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import VoxarLogoWhite from '../images/voxar-logo-white.png';
import VoxarLogoGray from '../images/voxar-logo-gray.png';
import SideMenu from './menu/SideMenu';
import { eventTypes, trackEvent } from '../helpers/AnalyticsManager';

import './NavBar.css';

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      slide: 0, // How much should the Navbar slide up or down
      lastScrollY: 0, // Keep track of current position in state
      scrollUpDelta: 0, // The distance of the upScroll
      height: 170,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
  }

  componentWillMount() {
    // When this component mounts, begin listening for scroll changes
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    // If this component is unmounted, stop listening
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { lastScrollY, height } = this.state;
    let { scrollUpDelta } = this.state;
    const currentScrollY = window.scrollY;

    if (currentScrollY < lastScrollY) {
      scrollUpDelta += lastScrollY - currentScrollY;
    } else {
      scrollUpDelta = 0;
    }

    if (window.pageYOffset <= 0 || scrollUpDelta > 100) {
      this.setState({ slide: '0px' });
    } else {
      this.setState({
        slide: `-${height}px`,
        middleOfPage: true,
      });
    }

    if (currentScrollY === 0) {
      this.setState({
        middleOfPage: false,
      });
    }

    this.setState({ lastScrollY: currentScrollY, scrollUpDelta });
  }

  scrollUp() {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top > 0) {
      window.scrollTo(0, top - 60);
      setTimeout(this.scrollUp, 0.1);
    }
  }

  render() {
    const { slide, middleOfPage } = this.state;
    const { darkMode } = this.props;

    let logo = darkMode ? VoxarLogoGray : VoxarLogoWhite;
    let contactColor = darkMode ? 'black' : 'white';
    let backgroundColor = 'transparent';

    if (middleOfPage) {
      logo = VoxarLogoWhite;
      contactColor = 'white';
      backgroundColor = 'var(--dark-background-black)';
    }

    return (
      <div
        className="NavBar"
        style={{
          transform: `translate(0, ${slide})`,
          transition: 'transform 0.2s ease-in-out, background-color 180ms ease',
          backgroundColor,
        }}
      >
        <Link to="/" className="NavBarHomeSection">
          <button
            type="button"
            onClick={this.scrollUp}
            className="NavBarHomeButton"
            style={{
              backgroundImage: `url(${logo})`,
            }}
          />
        </Link>

        <div className="NavBarRightBlock">
          <Link
            to="/contact"
            className="NavBarContactButton"
            style={{ color: contactColor }}
            onClick={() => {
              trackEvent(eventTypes.navbarContact);
              return true;
            }}
          >
            CONTATO
          </Link>
          <Link
            to="/english/home"
            className="NavBarContactButton2"
            style={{ color: contactColor }}
            onClick={() => {
              trackEvent(eventTypes.navbarContact);
              return true;
            }}
          >
            ENGLISH
          </Link>
          <SideMenu />
        </div>
      </div>
    );
  }
}

NavBar.propTypes = {
  darkMode: PropTypes.bool,
};

NavBar.defaultProps = {
  darkMode: false,
};

export default NavBar;
